import { PropertyConverter } from 'angular2-jsonapi'

export class ArrayConverter<T extends PropertyConverter>
    implements PropertyConverter {
    constructor(public converter: T) {}

    mask(value: any[]) {
        if (!Array.isArray(value)) {
            throw new Error('O parâmetro "value" deve ser um array.')
        }

        return value.map(item => this.converter.mask(item))
    }

    unmask(value: any[]) {
        if (!Array.isArray(value)) {
            throw new Error('O parâmetro "value" deve ser um array.')
        }

        return value.map(item => this.converter.unmask(item))
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/converters/array.converter.ts